import React from 'react'
import { TrendingDown, TrendingUp } from 'lucide-react';
import styled from 'styled-components';
import { FullyCentered } from 'styled/alignment/Center';
import colors from 'theme/colors';

export default function FinancialStatusIcon({ status }) {
    return (
        <TransactionIconCircle status={status} aria-label={status}>
            {status === 'withdraw' && <TrendingDown size={16} />}
            {status === 'refund' && <TrendingDown size={16} />}
            {status === 'sell' && <TrendingUp size={16} />}
        </TransactionIconCircle>
    )
}

const TransactionIconCircle = styled(FullyCentered)`
    border-radius: 50%;
    width: 36px;
    height: 36px;
    min-width: 36px;
    margin-right: 12px;
    transition: transform 0.15s ease;

    ${({ status }) => status === 'sell' && `
        background-color: #DCFCE7;
        & > svg {
            stroke: ${colors.success};
        }
    `}

    ${({ status }) => status === 'refund' && `
        background-color: ${colors.danger}12;
        & > svg {
            stroke: ${colors.dangerDark};
        }
    `}

    ${({ status }) => status === 'withdraw' && `
        background-color: ${colors.primary}12;
        & > svg {
            stroke: ${colors.primary};
        }
    `}
`;
